const comments = [
  {
    name: '追剧小达人',
    text: '用了青柠影视半年多了，更新速度真的快！热门剧基本当晚就能看，画质也很清晰，1080P 看起来太爽了，已经安利给身边所有追剧的朋友。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%2C%20warm%20lighting%2C%20casual%20style%2C%20friendly%20smile%2C%20clean%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-1-ql&orientation=squarish',
    date: '2026-07-28',
  },
  {
    name: '电影控老王',
    text: '之前找高清资源到处翻，现在青柠影视成了我的唯一选择。片库太全了，连很多冷门老片都有，而且播放一点都不卡，真的良心平台。',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20man%20in%2030s%20portrait%2C%20warm%20studio%20lighting%2C%20smart%20casual%20look%2C%20confident%20expression%2C%20clean%20neutral%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-2-ql&orientation=squarish',
    date: '2026-07-26',
  },
  {
    name: '动漫少女阿喵',
    text: '日漫资源太全了！从老番到新番都有，还都是高清中字。晚上窝在被窝里追番就是我一天最幸福的时刻，感谢青柠让我省了买会员的钱。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20glasses%20portrait%2C%20soft%20warm%20lighting%2C%20cozy%20vibe%2C%20friendly%20smile%2C%20clean%20pastel%20background%2C%20natural%20headshot%20style&width=120&height=120&seq=avatar-3-ql&orientation=squarish',
    date: '2026-07-24',
  },
  {
    name: '剧评人小李',
    text: '作为一个每天都在看剧的人，青柠影视的片源质量和更新速度让我印象深刻。界面简洁清爽，没有烦人的弹窗广告，追剧体验比很多付费平台还好。',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20man%20portrait%20in%2020s%2C%20warm%20natural%20lighting%2C%20casual%20stylish%20look%2C%20friendly%20expression%2C%20clean%20minimal%20background%2C%20modern%20headshot%20style&width=120&height=120&seq=avatar-4-ql&orientation=squarish',
    date: '2026-07-22',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
            影迷热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            听听真实用户怎么说，好口碑自己会说话
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-11 h-11 md:w-12 md:h-12 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-sm font-bold text-foreground-900">{item.name}</span>
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                  </div>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}